import Riders from '../images/riders.jpeg'
import Donuts from '../images/donuts.jpeg'
import Careers from '../images/careers.jpeg'

export const works = [
  {
    id: 1,
    image: Riders,
    title: 'Riders',
    text:
      'Become a rider and enjoy the freedom to fit work around your life. Plus great fees, perks and discounts.'
  },
  {
    id: 2,
    image: Donuts,
    title: 'Restaurants',
    text:
      'Partner with Foodya and reach more customers than ever. We handle delivery, so you can focus on the food.'
  },
  {
    id: 3,
    image: Careers,
    title: 'Careers',
    text:
      'Our mission is to change the way people eat. It is ambitious, but so are we. And we need people like you to help us do it.'
  }
]
